import { render, staticRenderFns } from "./interactionAddDialog.vue?vue&type=template&id=896a9cac&scoped=true"
import script from "./interactionAddDialog.vue?vue&type=script&lang=js"
export * from "./interactionAddDialog.vue?vue&type=script&lang=js"
import style0 from "./interactionAddDialog.vue?vue&type=style&index=0&id=896a9cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896a9cac",
  null
  
)

export default component.exports